import Vue from 'vue';

import JsSIP from 'jssip';
import moment from 'moment';
import store from '../store';
import NotifIncomingCall from '../assets/sound/notif-call-waiting.mp3';
import OutgoingRingback from '../assets/sound/CallWaiting_1.mp3';

let socket_sip = null;
let stream_local_sip = null;
// Maricall WhatsApp-calling softphone (WAP-358 / PD) — separate JsSIP UA, isolated here.
let socket_wa_sip = null;
// Ringback tone the AGENT hears while waiting for the customer to answer (outbound).
// Single shared instance, looped; started on SIP 180 (progress), stopped on
// accepted/confirmed/ended/failed.
let maricall_ringback = null;
function stopMaricallRingback() {
  try {
    if (maricall_ringback) {
      maricall_ringback.pause();
      maricall_ringback.currentTime = 0;
    }
  } catch (e) { /* ignore */ }
}
function startMaricallRingback() {
  try {
    if (!maricall_ringback) {
      maricall_ringback = new Audio(OutgoingRingback);
      maricall_ringback.loop = true;
      maricall_ringback.volume = 0.5;
    }
    maricall_ringback.currentTime = 0;
    maricall_ringback.play().catch(() => {});
  } catch (e) { /* ignore */ }
}

// ICE for the Maricall browser leg. The backend delivers real iceServers (Cloudflare
// STUN+TURN) in wa_call_access.access.ice_servers, already in RTCIceServer shape
// ([{ urls, username, credential }]) — used as-is. Public STUN is only a last-resort
// fallback if the backend ever returns none.
const DEFAULT_ICE_SERVERS = [];
function computeMaricallIce() {
  const ice = store.state.auth.wa_sip?.access?.ice_servers;
  // console.log('ice', ice);
  return (Array.isArray(ice) && ice.length) ? ice : DEFAULT_ICE_SERVERS;
}

Vue.mixin({
  data() {
    return {};
  },
  computed: {
    authSip() {
      return store.state.auth.sip || {};
    },
    SIPsocket() {
      if (this.authSip?.access?.extension) {
        const connect_sip = new JsSIP.WebSocketInterface(`wss://${store.state.auth.sip.access.domain}:${store.state.auth.sip.access.port}/ws`);
        const configuration = {
          sockets: [connect_sip],
          uri: `sip:${store.state.auth.sip.access.extension}@${store.state.auth.sip.access.domain}`,
          // password: process.env.VUE_APP_SIP_KEY,
          password: store.state.auth.sip.access.key,
          display_name: store.state.auth.userProfile.name,
        };
        socket_sip = new JsSIP.UA(configuration);
        return socket_sip;
      }
      return null;
    },
    // Maricall UA built from wa_call_access delivered at login (PD).
    waSIPsocket() {
      if (socket_wa_sip) return socket_wa_sip;
      const acc = store.state.auth.wa_sip?.access;
      if (acc?.sip_username && acc?.sip_password && acc?.sip_domain) {
        const ws_uri = `wss://${acc.sip_domain}`;
        const connect_wa = new JsSIP.WebSocketInterface(ws_uri);
        const configuration = {
          sockets: [connect_wa],
          uri: `sip:${acc.sip_username}@${acc.sip_domain}`,
          password: acc.sip_password,
          realm: acc.sip_realm,
          display_name: store.state.auth.userProfile?.name,
          register: true,
          // Build EVERY PeerConnection on this UA with TURN from the start. Passing
          // iceServers only via session.answer({pcConfig}) is fragile: JsSIP reuses
          // `_iceReady` across sessions, so a 2nd INVITE (re-dispatch) ships the answer
          // SDP mid-gathering — before the slow Cloudflare TURN `relay` candidate is in
          // it — and the SBC, which only sees our private host candidates, has nowhere
          // routable to send media → ICE fails. LAN (Asterisk) hides this because host
          // candidates are reachable; a remote NAT'd SBC (Maricall) does not.
          pcConfig: { iceServers: computeMaricallIce() },
        };
        socket_wa_sip = new JsSIP.UA(configuration);
        return socket_wa_sip;
      }
      return null;
    },
    isEnableMaricallCall() {
      return !!store.state.auth.wa_sip?.access?.sip_username;
    },
    streamLocal() {
      return stream_local_sip;
    },
  },
  mounted() {
  },
  methods: {
    checkSocketFalse() {
      return !store.state.workspace.activeWorkspace._id || store.state.auth.userProfile.agents[0]?.workspace_id !== store.state.workspace.activeWorkspace._id || !store.state.auth.sip?.access?.extension;
    },
    /**
     * Stop the VOIP call's local mic/camera tracks (the stream acquired in outgoingCall,
     * stored in the module-scoped stream_local_sip). Navbar's handleEndPhoneCall only
     * stops this.localStream (the WhatsApp/WebRTC call) — without this the VOIP mic track
     * stays live and the browser keeps showing the "recording"/mic indicator after hangup.
     */
    stopVoipLocalStream() {
      try {
        if (stream_local_sip) {
          stream_local_sip.getTracks().forEach((t) => t.stop());
          stream_local_sip = null;
        }
      } catch (e) { /* ignore */ }
    },
    async outgoingCall(convo) {
      let selected_contact = {};
      let cnv = {};
      if (convo.contacts) {
        selected_contact = convo.contacts.find((v) => v.channel === 'whatsapp');
        cnv = convo;
      } else {
        selected_contact = convo;
        cnv = {
          contacts: [selected_contact],
        };
      }
      let to_number = selected_contact.phone_number;
      if (selected_contact.phone_number.startsWith('62')) {
        to_number = `0${selected_contact.phone_number.substring(2)}`;
      } else {
        to_number = selected_contact.phone_number;
      }
      const constraints = {
        audio: {
          noiseSuppression: false,
          echoCancellation: false,
          autoGainControl: false,
          sampleRate: 48000,
          channelCount: 1,
        },
        // audio: true,
        video: false,
      };
      const local_stream = await navigator.mediaDevices.getUserMedia(constraints).catch(() => {
        navigator.permissions.query({ name: 'microphone' });
      });
      stream_local_sip = local_stream;
      const options = {
        eventHandlers: {
          peerconnection: ((e) => {
            console.log('call is in peer connecting');
            console.log(e);
            if (e.peerconnection) {
              console.log(e.peerconnection);
              e.peerconnection.ontrack = ((event) => {
                console.log(event);
              });
            } else {
              console.log('onSessionDescriptionHandler fired without a peerConnection');
            }
          }),
        },
        mediaConstraints: constraints,
        mediaStream: local_stream,
        data: {
          conversation: cnv,
        },
      };
      const session = socket_sip.call(`sip:${to_number}@${store.state.auth.sip.access.domain}`, options);
      await this.$store.dispatch('ui/setActiveCall', {
        callReceived: true,
        callSession: session.id,
        data: session.data,
        toNumber: selected_contact.phone_number,
        // socket: this.SIPsocket,
      });
    },

    /**
     * Register the Maricall softphone and handle inbound WhatsApp calls as SIP
     * INVITEs. Media is bridged by Maricall; call records / billing / recording
     * are handled server-side by chat-api (no Meta callAction, no MediaRecorder).
     * Reuses the existing call UI data (phone_call/call/call_session/preview
     * modals + <audio id="audio">) on the host component (Navbar).
     */
    setupMaricallPhone() {
      const ua = this.waSIPsocket;
      if (!ua) return;
      // DIAGNOSTIC (outbound debugging): print full SIP wire so we can see the FS Maricall
      // response to our outbound INVITE (e.g. 403/404/488/480) when the call dies instantly.
      try { JsSIP.debug.enable('JsSIP:*'); } catch (e) { /* ignore */ }
      // Start + bind listeners exactly once per UA. Re-binding `newRTCSession` (e.g.
      // on a Navbar re-mount) would make a single INVITE open the incoming-call UI
      // multiple times.
      if (ua.__maricallBound) return;
      ua.__maricallBound = true;
      try {
        ua.start();
      } catch (e) {
        console.log('maricall ua start error', e);
      }
      ua.on('connected', () => console.log('maricall sip connected'));
      ua.on('disconnected', () => console.log('maricall sip disconnected'));
      ua.on('registered', () => console.log('maricall sip registered'));
      ua.on('registrationFailed', (e) => console.log('maricall sip registrationFailed', e));

      ua.on('newRTCSession', async (e) => {
        this.maricall_active = true;
        this.call_session = e;
        this.pc = e.session.connection;
        this.remoteStream = new MediaStream();
        this.call_direction = e.session.direction;
        // Detect a real video offer from the inbound SDP. An audio-only call can still
        // carry a disabled `m=video 0` line, so only treat it as video when the video
        // m-line has a non-zero port (otherwise answering with video:true asks for a
        // camera we may not have and the call dies on accept).
        const inbound_sdp = (e.session._request && e.session._request.body) || '';
        const video_mline = inbound_sdp.match(/m=video\s+(\d+)/);
        // Only derive video from the inbound offer for incoming calls. For outgoing
        // (Maricall outbound), the video intent is already set by outgoingMaricallCall()
        // from the call type — don't clobber it here.
        if (e.session.direction === 'incoming') {
          this.maricall_video = !!video_mline && video_mline[1] !== '0';
        }
        // Diagnostics: is the SBC offer a WebRTC media leg? A browser RTCPeerConnection
        // REQUIRES DTLS (a=fingerprint) + ICE (a=ice-ufrag) + a *DTLS/SAVPF profile. If
        // the offer is plain RTP/AVP (no fingerprint/ice), the PC can't connect (stays
        // 'connecting') and Maricall must enable WebRTC on the agent leg.
        if (e.session.direction === 'incoming') {
          console.log('[maricall] offer m=audio:', (inbound_sdp.match(/m=audio[^\r\n]*/) || [''])[0]);
          console.log('[maricall] offer hasDTLS:', /a=fingerprint/.test(inbound_sdp),
            '| hasICE:', /a=ice-ufrag/.test(inbound_sdp),
            '| setup:', (inbound_sdp.match(/a=setup:[^\r\n]*/) || [''])[0]);
          // The SBC's connection address + any ICE candidates it offered. If c= is a
          // private/non-routable IP and there are no usable a=candidate lines, our TURN
          // can't reach the SBC media — that's a Maricall-side media-reachability issue.
          console.log('[maricall] offer c=:', (inbound_sdp.match(/c=[^\r\n]*/g) || []).join(' | '));
          console.log('[maricall] offer candidates:', (inbound_sdp.match(/a=candidate:[^\r\n]*/g) || []).length, (inbound_sdp.match(/a=candidate:[^\r\n]*/g) || []));
          console.log('[maricall] FULL inbound offer SDP:\n', inbound_sdp);
        }

        if (e.session.direction === 'incoming') {
          this.soundIncomingCall = [];
          try {
            const devices = await navigator.mediaDevices.enumerateDevices();
            const speakers = devices.filter((u) => u.kind === 'audiooutput');
            speakers.forEach((device) => this.soundIncomingCall.push({
              audio: new Audio(NotifIncomingCall), deviceId: device.deviceId, label: device.label,
            }));
            await Promise.all(this.soundIncomingCall.map(async (s) => {
              try { await s.audio.setSinkId(s.deviceId); } catch (err) { /* ignore */ }
              s.audio.loop = true;
              s.audio.volume = 0.7;
              s.audio.play().catch(() => {});
            }));
          } catch (err) {
            console.log('maricall ring error', err);
          }

          const user = (e.session.remote_identity && e.session.remote_identity.uri && e.session.remote_identity.uri.user) || '';
          const pop = this.maricallScreenPop || {};
          this.phone_call = {
            status: 'Incoming Call...',
            mic: 'mdi mdi-microphone mdi-22px',
            volume: 'mdi mdi-volume-low mdi-22px',
            video: 'mdi mdi-video-off mdi-22px',
            name: pop.name || 'WhatsApp Call',
            channel: 'WhatsApp',
            phone_number: user,
            conversation_id: pop.conversation_id || '',
            workspace_id: this.activeWorkspace && this.activeWorkspace._id,
            msg_id: pop.external_call_id || '',
            id: '',
            ivr_context: pop.ivr_context || null,
          };
          this.call.startCall = moment.utc();
          this.showModalMinimizeCall = true;
        }

        const attachTrack = (event) => {
          const audio = document.querySelector('audio#audio');
          if (audio) audio.srcObject = event.streams[0];
          event.streams[0].getTracks().forEach((track) => {
            if (track) this.remoteStream.addTrack(track);
          });
          if (event.streams[0].getVideoTracks().length > 0) {
            this.maricall_video = true;
            const videoEl = document.querySelector('video#wa-remote-video')
              || (this.$refs.prevMinCall && this.$refs.prevMinCall.$el && this.$refs.prevMinCall.$el.querySelector('video'));
            if (videoEl) videoEl.srcObject = event.streams[0];
          }
        };
        // Diagnostics: surface ICE/connection state so we can tell whether media
        // actually established. If it reaches 'failed'/'disconnected' (signaling OK
        // but no media), the agent's network needs TURN — STUN alone isn't enough.
        // Dump every ICE candidate pair the browser tried: which local↔remote combo,
        // its state (succeeded/failed/in-progress), and bytes moved. This is the
        // definitive "us vs SBC" artifact — if a relay(104.30.x)↔SBC(161.248.116.160)
        // pair shows state 'failed' with 0 bytes received, our routable address reached
        // them and they didn't answer the connectivity check → SBC-side.
        const dumpIcePairs = async (pc) => {
          try {
            const stats = await pc.getStats();
            const local = {}; const remote = {};
            stats.forEach((r) => {
              if (r.type === 'local-candidate') local[r.id] = r;
              if (r.type === 'remote-candidate') remote[r.id] = r;
            });
            const pairs = [];
            stats.forEach((r) => {
              if (r.type !== 'candidate-pair') return;
              const l = local[r.localCandidateId] || {};
              const rm = remote[r.remoteCandidateId] || {};
              pairs.push({
                state: r.state,
                nominated: r.nominated,
                local: `${l.candidateType} ${l.protocol} ${l.address || l.ip}:${l.port}`,
                remote: `${rm.candidateType} ${rm.protocol} ${rm.address || rm.ip}:${rm.port}`,
                bytesRecv: r.bytesReceived,
                bytesSent: r.bytesSent,
                requestsSent: r.requestsSent,
                responsesRecv: r.responsesReceived,
              });
            });
            console.log('[maricall] ICE candidate pairs:', JSON.stringify(pairs, null, 2));
          } catch (err) { console.log('[maricall] getStats failed', err); }
        };
        const bindIceDiag = (pc) => {
          if (!pc) return;
          pc.oniceconnectionstatechange = () => {
            console.log('[maricall] iceConnectionState:', pc.iceConnectionState);
            if (pc.iceConnectionState === 'failed' || pc.iceConnectionState === 'disconnected') dumpIcePairs(pc);
          };
          pc.onconnectionstatechange = () => {
            console.log('[maricall] connectionState:', pc.connectionState);
            if (pc.connectionState === 'failed') dumpIcePairs(pc);
          };
          pc.onicegatheringstatechange = () => console.log('[maricall] iceGatheringState:', pc.iceGatheringState);
          // Log local candidate TYPES: if a `relay` candidate appears, our TURN works
          // and any ICE failure is the remote (SBC) side; if NO relay shows, TURN
          // allocation failed (bad creds / TURN unreachable).
          pc.onicecandidate = (ev) => {
            if (ev.candidate) {
              console.log('[maricall] local candidate:', ev.candidate.type, ev.candidate.protocol, '|', ev.candidate.candidate);
            } else {
              console.log('[maricall] local candidate gathering DONE');
            }
          };
        };
        if (this.pc) { this.pc.ontrack = attachTrack; bindIceDiag(this.pc); }
        e.session.on('peerconnection', (peer) => {
          this.pc = peer.peerconnection;
          this.pc.ontrack = attachTrack;
          bindIceDiag(this.pc);
        });

        e.session.on('progress', (p) => {
          console.log('[maricall] session progress', p && p.response && p.response.status_code);
          if (e.session.direction === 'outgoing') {
            this.phone_call.status = 'Ringing...';
            this.call.startCall = moment.utc();
            // SIP 180 Ringing → play ringback so the agent hears the call is ringing
            // while waiting for the customer to answer.
            startMaricallRingback();
          }
        });
        e.session.on('accepted', () => {
          if (e.session.direction === 'incoming') {
            this.soundIncomingCall.forEach((item) => { item.audio.pause(); item.audio.currentTime = 0; });
          }
          stopMaricallRingback();
          this.phone_call.status = 'Connecting...';
        });
        e.session.on('confirmed', () => {
          stopMaricallRingback();
          this.call.startTime = moment.utc();
          this.phone_call.status = 'You are on a call with a customer';
          // Duration display only — billing is driven by chat-api via Maricall webhooks.
          this.call.talktime = window.setInterval(() => {
            const duration = moment().diff(moment(this.call.startTime), 'second');
            this.call.duration = duration > 3600
              ? moment.utc(duration * 1000).format('HH:mm:ss')
              : moment.utc(duration * 1000).format('mm:ss');
          }, 1000);
        });
        e.session.on('ended', (end) => {
          console.log('[maricall] session ended — originator:', end && end.originator, 'cause:', end && end.cause);
          if (end) end.status = 'ended';
          this.endMaricallCall(end);
        });
        e.session.on('failed', (end) => {
          console.log('[maricall] session FAILED — originator:', end && end.originator,
            'cause:', end && end.cause,
            'status:', end && end.message && end.message.status_code,
            'reason:', end && end.message && end.message.reason_phrase);
          if (end) end.status = 'failed';
          this.soundIncomingCall.forEach((item) => { item.audio.pause(); item.audio.currentTime = 0; });
          this.endMaricallCall(end);
        });
      });
    },

    answerMaricallCall(withVideo = false) {
      this.soundIncomingCall.forEach((item) => { item.audio.pause(); item.audio.currentTime = 0; });
      const session = this.call_session && this.call_session.session;
      if (session) this.prepareMaricallAnswer(session);
      const options = {
        mediaConstraints: {
          audio: { noiseSuppression: true, echoCancellation: true, autoGainControl: true },
          video: !!withVideo || !!this.maricall_video,
        },
        pcConfig: { iceServers: computeMaricallIce() },
        sessionTimersExpires: 120, // FS Maricall Min-SE is 120 (JsSIP default 90 → 422)
      };
      if (session) session.answer(options);
    },

    /**
     * Outbound WhatsApp call via Maricall (agent-initiated). The browser agent (already
     * REGISTERED to FS Maricall — same UA as inbound, `waSIPsocket`) sends a SIP.js INVITE
     * to `sip:<E.164>@<maricall-domain>`. Maricall then originates the customer leg by
     * calling our public `POST /v1/calls` (connect) and bridges the media. We do NOT hit
     * chat-api/executeCall here — that is the legacy direct-WebRTC path.
     *
     * Number format: E.164 WITHOUT '+' and WITHOUT the VOIP `62→0` conversion that
     * legacy `outgoingCall` applies — Maricall expects `628xxx` (memory: maricall outbound).
     *
     * The shared `newRTCSession` handler (setupMaricallPhone) catches this session
     * (direction 'outgoing') and wires pc/tracks/progress/confirmed/ended, so here we only
     * prepare media + the outgoing call UI + the ICE-gathering debounce on the offer.
     */
    async outgoingMaricallCall(convo, type = 'call') {
      const acc = store.state.auth.wa_sip?.access;
      const ua = this.waSIPsocket;
      if (!ua || !acc?.sip_domain) { console.log('[maricall] outbound: no registered UA'); return; }
      // The browser must be registered to FS Maricall before we can INVITE. setupMaricallPhone()
      // starts/registers the UA on mount; if it isn't ready yet, tell the agent to retry.
      if (typeof ua.isRegistered === 'function' && !ua.isRegistered()) {
        console.log('[maricall] outbound: UA not registered yet');
        if (this.$message) this.$message({ type: 'warning', message: 'Call service not ready yet, please try again in a moment.' });
        return;
      }

      let selected_contact = {};
      if (convo && convo.contacts) {
        selected_contact = convo.contacts.find((v) => v.channel === 'whatsapp') || {};
      } else {
        selected_contact = convo || {};
      }
      // E.164, no '+', no 62→0 conversion (unlike legacy outgoingCall / VOIP).
      const to_number = String(selected_contact.phone_number || '').replace(/[^\d]/g, '');
      if (!to_number) { console.log('[maricall] outbound: missing phone_number'); return; }

      const constraints = {
        audio: { noiseSuppression: true, echoCancellation: true, autoGainControl: true },
        video: type === 'video_call',
      };
      const local_stream = await navigator.mediaDevices.getUserMedia(constraints).catch((e) => {
        console.log('[maricall] outbound getUserMedia failed', e);
        return null;
      });
      if (!local_stream) return;
      stream_local_sip = local_stream;
      this.maricall_active = true;
      this.maricall_video = type === 'video_call';
      this.call_direction = 'outgoing';
      this.call.startCall = moment.utc();
      this.phone_call = {
        status: 'Calling...',
        mic: 'mdi mdi-microphone mdi-22px',
        volume: 'mdi mdi-volume-low mdi-22px',
        video: type === 'video_call' ? 'mdi mdi-video mdi-22px' : 'mdi mdi-video-off mdi-22px',
        name: selected_contact.name || selected_contact.phone_number || 'WhatsApp Call',
        channel: 'WhatsApp',
        phone_number: selected_contact.phone_number || to_number,
        conversation_id: (convo && convo.id) || '',
        workspace_id: this.activeWorkspace && this.activeWorkspace._id,
        msg_id: '',
        id: '',
        ivr_context: null,
      };
      if (type === 'video_call') this.showModalMaximizeCall = true;
      else this.showModalMinimizeCall = true;

      const options = {
        mediaConstraints: constraints,
        mediaStream: local_stream,
        pcConfig: { iceServers: computeMaricallIce() },
        // FS Maricall requires Min-SE 120; JsSIP's default Session-Expires is 90 → 422
        // (Session Interval Too Small). Match their minimum.
        sessionTimersExpires: 120,
        data: { conversation: convo },
      };
      const session = ua.call(`sip:${to_number}@${acc.sip_domain}`, options);
      // Same ICE-gathering debounce as the answer path — JsSIP blocks the outgoing INVITE
      // on gathering 'complete' too, which stalls behind NAT.
      if (session) this.prepareMaricallAnswer(session);
    },

    /**
     * ROOT CAUSE of the "call connects but no media / ICE failed" bug:
     * JsSIP 3.13.6's _createLocalDescription waits for iceGatheringState === 'complete'
     * before emitting the answer SDP / sending the 200 OK (RTCSession.js ~L1424/L1474).
     * Behind this NAT, gathering NEVER completes in time (Cloudflare TURN keeps the agent
     * in 'gathering'), so the 200 OK with our SDP is never sent → the SBC never receives
     * our candidates → zero ICE pairs form → connectionState goes straight to 'failed'.
     * That's why the answer-SDP log and the createAnswer/setLocalDescription failure logs
     * never appeared, even though candidates were gathered. Asterisk (LAN) gathers fast
     * enough to hit 'complete', so it never tripped this.
     *
     * Fix: JsSIP emits a session-level 'icecandidate' event with a `ready()` callback for
     * every candidate. We debounce it — call ready() shortly after the first srflx/relay
     * (server-reflexive/relay) candidate, or after a hard timeout — so JsSIP sends the
     * answer promptly with at least one routable candidate instead of blocking on
     * 'complete'. The SBC offers a PUBLIC host candidate, so one srflx/relay is enough.
     */
    prepareMaricallAnswer(session) {
      if (!session || session.__maricallAnswerPrepared) return;
      session.__maricallAnswerPrepared = true;

      let sent = false;
      let hardTimer = null;
      let lastReady = null; // JsSIP hands the same `ready` fn with every candidate
      const flush = (why) => {
        if (sent) return;
        sent = true;
        if (hardTimer) clearTimeout(hardTimer);
        console.log('[maricall] sending answer SDP now —', why);
        if (typeof lastReady === 'function') lastReady();
      };
      session.on('icecandidate', (data) => {
        lastReady = data && data.ready;
        // Hard cap: send the answer at 1.5s no matter what, so a stuck TURN allocation
        // can't block the 200 OK forever.
        if (!hardTimer) hardTimer = setTimeout(() => flush('1.5s timeout'), 1500);
        const cand = (data && data.candidate && data.candidate.candidate) || '';
        // As soon as we have a routable candidate (srflx or relay), stop waiting —
        // tiny grace so a relay can join the srflx in the same SDP.
        if (/typ srflx/.test(cand) || /typ relay/.test(cand)) {
          setTimeout(() => flush('have routable candidate'), 250);
        }
      });

      session.on('sdp', (e) => {
        // Applies to BOTH our outgoing offer and our answer (JsSIP blocks on ICE
        // gathering 'complete' for either — same root cause).
        if (e.originator !== 'local') return;
        // Force DTLS setup:active on OUR OFFER (outgoing INVITE). Browsers default the
        // offer to `a=setup:actpass`; FS Maricall asked us to be the DTLS client
        // (`active`) so they act as server (`passive`). Mutating e.sdp here works because
        // JsSIP sends back the (possibly modified) e.sdp (RTCSession.js returns e.sdp
        // after emitting 'sdp'). Only touch the offer — the answer's role is already
        // negotiated, forcing it would break DTLS.
        if (e.type === 'offer' && /a=setup:actpass/.test(e.sdp)) {
          e.sdp = e.sdp.replace(/a=setup:actpass/g, 'a=setup:active');
          console.log('[maricall] forced a=setup:active on outgoing offer');
        }
        const relay = (e.sdp.match(/a=candidate:[^\r\n]*typ relay[^\r\n]*/g) || []);
        const srflx = (e.sdp.match(/a=candidate:[^\r\n]*typ srflx[^\r\n]*/g) || []);
        console.log(`[maricall] ${e.type} candidates on wire — relay:`, relay.length, 'srflx:', srflx.length);
        console.log(`[maricall] FULL ${e.type} SDP:\n`, e.sdp);
      });
      // Surface where the answer dies if it never reaches the 'sdp' emit above.
      session.on('peerconnection:setremotedescriptionfailed', (err) => console.log('[maricall] setRemoteDescription FAILED', err));
      session.on('peerconnection:createanswerfailed', (err) => console.log('[maricall] createAnswer FAILED', err));
      session.on('peerconnection:setlocaldescriptionfailed', (err) => console.log('[maricall] setLocalDescription FAILED', err));
    },

    /** ICE servers for the Maricall leg (server-delivered if present, else STUN fallback). */
    maricallIceServers() {
      return computeMaricallIce();
    },

    /**
     * Maricall-safe end: terminate the Maricall SIP session + reset call UI.
     * The WhatsApp/Meta leg is owned by Maricall's engine (the call entered Maricall
     * first), so the SIP BYE we send here propagates to Maricall, which ends the Meta
     * leg. We do NOT issue a Meta call-action ourselves.
     */
    endMaricallCall() {
      this.soundIncomingCall.forEach((item) => { item.audio.pause(); item.audio.currentTime = 0; });
      stopMaricallRingback();
      clearInterval(this.call.talktime);
      try { if (socket_wa_sip) socket_wa_sip.terminateSessions(); } catch (e) { /* ignore */ }
      // Stop the local mic/camera tracks so the browser's "recording" (mic) indicator
      // turns off. For OUTBOUND we acquired stream_local_sip ourselves (JsSIP won't stop
      // a stream we passed in); for INBOUND JsSIP owns its stream but stopping again is
      // harmless. Also stop any track still on the peer connection's senders.
      try {
        if (stream_local_sip) {
          stream_local_sip.getTracks().forEach((t) => t.stop());
          stream_local_sip = null;
        }
      } catch (e) { /* ignore */ }
      try {
        if (this.pc && this.pc.getSenders) {
          this.pc.getSenders().forEach((s) => { if (s.track) s.track.stop(); });
        }
      } catch (e) { /* ignore */ }
      this.$store.dispatch('ui/clearActiveCall');
      this.remoteStream = null;
      this.pc = null;
      this.call_session = {};
      this.maricall_active = false;
      this.maricall_video = false;
      this.showModalMinimizeCall = false;
      this.showModalMaximizeCall = false;
      this.isPhoneMuted = false;
      this.isOffCam = true;
      this.call = {
        duration: 0, startTime: '', talktime: 0, startCall: '',
      };
      this.phone_call = {
        status: 'Calling...',
        mic: 'mdi mdi-microphone mdi-22px',
        video: 'mdi mdi-video-off mdi-22px',
        volume: 'mdi mdi-volume-low mdi-22px',
        name: '',
        channel: 'WhatsApp',
        phone_number: '',
        conversation_id: '',
        workspace_id: '',
        msg_id: '',
        id: '',
      };
      // Also clear the screen-pop so a stale IVR context can't leak into the next call.
      this.maricallScreenPop = null;
    },

    /** Screen-pop pushed by chat-api over socket (wa_call_event): IVR path + caller. */
    onMaricallScreenPop(data) {
      if (!data) return;
      // chat-api broadcasts to the whole workspace call room and tags the dispatched
      // agent's sip_username (agent.dispatched only reaches one agent). Only that
      // agent applies the screen-pop; everyone else ignores it.
      const mySip = store.state.auth.wa_sip?.access?.sip_username;
      if (data.sip_username && mySip && data.sip_username !== mySip) return;
      this.maricallScreenPop = {
        external_call_id: data.external_call_id,
        ivr_context: data.ivr_context || null,
        name: (data.contact && (data.contact.name || data.contact.display_name)) || data.name,
        conversation_id: data.conversation_id || (data.contact && data.contact.conversation_id),
      };
      if (this.showModalMinimizeCall && this.phone_call) {
        if (this.maricallScreenPop.name) this.phone_call.name = this.maricallScreenPop.name;
        this.phone_call.ivr_context = this.maricallScreenPop.ivr_context;
      }
    },

    teardownMaricallPhone() {
      try {
        if (socket_wa_sip) {
          socket_wa_sip.terminateSessions();
          socket_wa_sip.stop();
        }
      } catch (e) { /* ignore */ }
      // Drop the UA so the singleton getter builds a fresh one (with fresh listeners)
      // on the next setup/login.
      socket_wa_sip = null;
    },
  },
});
